import { NgModule } from '@angular/core';
import { UserMetaDataByKeyPipe } from './user-meta-data-by-key.pipe';

@NgModule({
    declarations: [UserMetaDataByKeyPipe],
    exports: [UserMetaDataByKeyPipe],
})
export class UserMetaDataByKeyPipeModule {}
